const addtb = [
  {
    inputdata: "",
    title: "原经销商",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "200px",
    btx: false,
    event: "TBnewChage",
    lablewith: "90px",
  },

  {
    inputdata: "",
    title: "原经销商编号",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "200px",
    lablewith: "90px",
    disabled: true,
  },
  {
    inputdata: "",
    title: "原经销商类型 ",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "200px",
    lablewith: "95px",
    disabled: true,
  },
  {
    inputdata: "",
    title: "调出仓库",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请选择",
    types: "",
    inputtype: "select",
    width: "210px",
    btx: false,
    options: [],
    lablewith: '90px',
  },
  {
    inputdata: "",
    title: "新经销商",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "200px",
    btx: true,
    event: "TBChage",
    lablewith: "90px",
  },
  {
    inputdata: "",
    title: "新经销商编号",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "200px",
    lablewith: "95px",
    disabled: true,
  },
  {
    inputdata: "",
    title: "新经销商类型 ",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "200px",
    lablewith: "92px",
    disabled: true,
  },
  {
    inputdata: "",
    title: "调入仓库",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请选择",
    types: "",
    inputtype: "select",
    width: "210px",
    btx: false,
    options: [],
    lablewith: "90px",
  },
  {
    inputdata: "",
    title: "产品线",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请选择",
    types: "",
    inputtype: "select",
    width: "210px",
    btx: true,
    options: [],
    lablewith: "95px",
    event: "invClass",
  },
  {
    inputdata: "",
    title: "调拨原因",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "200px",
    lablewith: "90px",
  },
  {
    inputdata: "",
    title: "调拨备注",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "200px",
    lablewith: "90px",
  },
];
export default addtb;
